/* eslint-disable max-lines */
import moment from 'moment';
import {reverseShortDate, hourFormat, labelDateFormat} from '../constants/datesFormat';

// eslint-disable-next-line max-statements
export const drawBinningLabel = (item) => {
  // const labelType = item.labelType === 'STOCK' ? 'I/I' : 'B/O';
  const textPartName = item.partName.substring(0, 40);
  const dateFormatted = item.printingDate ? moment(item.printingDate).format(labelDateFormat) : '';
  const invoice = item.labelType === 'STOCK' && item.invoice.length > 10 ? item.invoice.slice(0, 10) : item.invoice;
  const textInvoice = item.labelType === 'STOCK' ? `${invoice} - ${item.box}` : `${invoice}`;
  const storageCar = item.storageCar || '';
  let lineCode = '';

  if (item.labelType === 'STOCK' && item.lineCode) {
    lineCode = item.lineCode.split('-').pop();
  }

  let bgTDE = `^FO325,16
      ^GB225,20,20^FS`;
  let storageCarSection = `^FO135,16
      ^GB100,20,20^FS
      ^FO136,15
      ^ADN,25,12^FR^FDCOCHE  :^FS
      ^FO250,15
      ^ADN,25,12^FR^FD${storageCar}^FS`;
  let bgPartCode = `^FO135,46
      ^GB100,20,20^FS`;
  let bgQuantity = `^FO500,46
      ^GB120,20,20^FS`;
  let labelQuantity = `^FO502,48
      ^ADN,25,12^FR^FDCANTIDAD :^FS`;
  let textQuantity = `^FO630,48
      ^ADN,25,12^FR^FD${item.partQuantity}^FS`;
  let bgDescription = `^FO135,76
      ^GB100,20,20^FS`;
  let bgInvoice = `^FO135,106
      ^GB100,20,20^FS`;
  let labelBox = '';
  let textBox = '';
  let labelOrderNumber = '';
  let textOrderNumber = '';
  let barcode = `^FO145,138
      ^BY2
      ^B3N,N,55,Y,N
      ^FD${lineCode}^FS`;
  let bgLocation = `^FO500,116
      ^GB120,20,20^FS`;
  let labelLocation = `^FO502,118
      ^ADN,25,12^FR^FDUBICACION:^FS`;
  let textLocation = `^FO500,148
      ^ADN,45,22^FR^FD${item.partLocation}^FS`;
  let agengy = '';

  if (item.labelType === 'BACK ORDER') {
    const dealer = item.dealerAlias ? `${item.dealerAlias}` : `${item.dealer.substring(0, 5)}`;

    bgTDE = `^FO115,8
      ^GB615,153,153^FS`;
    storageCarSection = '';
    bgPartCode = '';
    bgQuantity = '';
    labelQuantity = `^FO502,48
      ^ADN,25,12^FR^FDCANT :^FS`;
    textQuantity = `^FO590,48
      ^ADN,25,12^FR^FD${item.partQuantity}^FS`;
    bgDescription = '';
    bgInvoice = '';
    labelBox = `^FO502,108
      ^ADN,25,12^FR^FDCAJA :^FS`;
    textBox = `^FO590,108
      ^ADN,25,12^FR^FD${item.box}^FS`;
    labelOrderNumber = `^FO502,138
      ^ADN,25,12^FR^FDPEDIDO:^FS`;
    textOrderNumber = `^FO590,138
      ^ADN,25,12^FR^FD${item.orderNumber}^FS`;
    barcode = '';
    if (item.orderSequence) {
      barcode = `^FO145,165
        ^BY2
        ^B3N,N,48,Y,N
        ^FD${item.orderSequence}^FS`;
    }
    bgLocation = '';
    labelLocation = '';
    textLocation = '';
    agengy = `^FO135,138
      ^ADN,18,10^FR^FD${dealer} ${item.agency}^FS`;
  }

  const zpl = `^XA
    ^MD3
    ${bgTDE}
    ^FO135,18
    ^ADN,25,12^FR^FDUsuario: ${item.orderUser}^FS
    ^FO500,18
    ^ADN,25,12^FR^FDOR: ${item.orderRepair}^FS
    ${storageCarSection}
    ${bgPartCode}
    ^FO136,48
    ^ADN,25,12^FR^FDCODIGO :^FS
    ^FO250,48
    ^ADN,25,12^FR^FD${item.partFranchise}  ${item.partCode}^FS
    ${bgQuantity}
    ${labelQuantity}
    ${textQuantity}
    ${bgDescription}
    ^FO136,78
    ^ADN,25,12^FR^FDDESCRIP:^FS
    ^FO250,78
    ^ADN,25,12^FR^FD${textPartName}^FS
    ${bgInvoice}
    ^FO136,108
    ^ADN,25,12^FR^FDFACTURA:^FS
    ^FO250,108
    ^ADN,25,12^FR^FD${textInvoice}^FS
    ${labelBox}
    ${textBox}
    ${bgLocation}
    ${labelLocation}
    ${textLocation}
    ${labelOrderNumber}
    ${textOrderNumber}
    ${barcode}
    ${agengy}
    ^FO500,198
    ^ADN,18,10^FR^FD${dateFormatted}^FS
    ^XZ`;

  return zpl;
};

export const drawLocationLabel = (location) => {
  return `^XA
  ^FO130,25
  ^ADN,85,50
  ^FD${location}^FS  
  ^FO130,110^BY3
  ^B3N,N,90,Y,N
  ^FD${location}^FS  
  ^XZ`;
};

const drawVerticalLine = (positionX, positionY, height) => {
  return `^FO${positionX},${positionY}
    ^GB1,${height},3^FS`;
};

const drawVerticalLineInverted = (positionX, positionY, height) => {
  return `^FO${positionX},${positionY}^FR
    ^GB1,${height},3^FS`;
};

const drawHorizontalLine = (positionX, positionY) => {
  return `^FO${positionX},${positionY}
    ^GB640,1,3^FS`;
};

const drawHorizontalLineInverted = (positionX, positionY) => {
  return `^FO${positionX},${positionY}^FR
    ^GB640,1,3^FS`;
};

const drawHorizontalLineComplete = (positionX, positionY, positionZ) => {
  return `^FO${positionX},${positionY}
    ^GB${positionZ},1,3^FS`;
};

const drawHorizontalLineInvertedComplete = (positionX, positionY, positionZ) => {
  return `^FO${positionX},${positionY}^FR
    ^GB${positionZ},1,3^FS`;
};

const backgroundInverted = (inverted, {positionX, positionY}, {width, heigth}) => {
  let code = `^FO${positionX},${positionY}^FR`;
  if (inverted) {
    code += `^GB${width},${heigth},${heigth}^FS`;
    return code;
  }
  code += `^GB${width},${heigth},${heigth}^FS`;
  return code;
};

const separatePartCode = (input) => {
  const segments = (input || ' ').match(/.{1,5}/g);
  const lastSegment = segments.pop();
  
  if (lastSegment.length < 5 && segments.length > 0) {
    segments[segments.length - 1] = `${segments[segments.length - 1]}-${lastSegment}`;
  } else {
    segments.push(lastSegment);
  }
  return segments.join('-');
};

export const drawPickingLabel = (item, inverted) => {
  const dateFormatted = item.date ?
    moment(item.date).format(reverseShortDate) :
    '';
  const hourFormatted = item.date ? moment(item.date).format(hourFormat) : '';
  const barcode = `^FO50,420
    ^BY2
    ^B3N,N,110,Y,N^FR
    ^FD${item.orderSequence}^FS`;
  const bgTDE = `^FO50,30
    ^ADN,30,12^FR`;
  const border = `^FO15,70
    ^GB645,337,${inverted ? 170 : 7}^FS`;
  const barcodeBorder = `^FO15,400
    ^GB645,170,7^FS`;
  const titleSize = '^ADN,25,12^FR';
  const smallSize = '^ADN,18,10^FR';
  const bolderSize = '^ADN,35,20^FR';
  const bolderBiggerSize = '^ADN,45,25^FR';
  const slimSize = '^ADN,30,12^FR';

  return `^XA
    ${bgTDE}
    ^FO50,45
    ^ADN,26,14^FR^FDUsuario: ${item.user}^FS
    ^FO370,45
    ${titleSize}
    ^FDPicking^FS
    ^FO500,25
    ^CF0,55
    ^FD${item.sequence}^FS
    ${border}
    ^FO90,85
    ${titleSize}
    ^FDUBICACION^FS
    ${drawVerticalLine(265, 70, 110)}
    ${inverted ? drawVerticalLineInverted(265, 70, 110) : ''}
    ^FO280,85
    ${titleSize}
    ^FDPEDIDO^FS
    ${drawVerticalLine(365, 70, 110)}
    ${inverted ? drawVerticalLineInverted(365, 70, 110) : ''}
    ^FO375,85
    ${titleSize}
    ^FDTIPO^FS
    ${drawVerticalLine(430, 70, 110)}
    ${inverted ? drawVerticalLineInverted(430, 70, 110) : ''}
    ^FO470,85
    ${titleSize}
    ^FDFECHA^FS
    ${drawVerticalLine(575, 70, 110)}
    ${inverted ? drawVerticalLineInverted(575, 70, 110) : ''}
    ^FO590,85
    ${titleSize}
    ^FDHORA^FS
    ${drawHorizontalLine(15, 110)}
    ${inverted ? drawHorizontalLineInverted(15, 110) : ''}
    ^FO35,130
    ${bolderSize}
    ^FD${item.location}^FS   
    ^FO290,135
    ${smallSize}
    ^FD${item.order}^FS
    ^FO380,125
    ${bolderBiggerSize}
    ^FD${item.type}^FS
    ^FO440,135
    ${smallSize}
    ^FD${dateFormatted}^FS
    ^FO582,135
    ${smallSize}
    ^FD${hourFormatted}^FS
    ${drawHorizontalLine(15, 180)}
    ${inverted ? drawHorizontalLineInverted(15, 180) : ''}
    ^FO35,195
    ${titleSize}
    ^FDCODIGO DE  REPUESTO^FS

    ${drawVerticalLine(430, 180, 110)}
    ${inverted ? drawVerticalLineInverted(430, 180, 110) : ''}
    
    ^FO490,195
    ${titleSize}
    ^FDCANTIDAD^FS
    ${drawHorizontalLine(15, 220)}
    ${inverted ? drawHorizontalLineInverted(15, 220) : ''}
    ${backgroundInverted(
    inverted,
    {'positionX': 22, 'positionY': 223},
    {'width': 631, 'heigth': 70}
  )}
    ^FO25,240
    ${bolderSize}
    ^FD${separatePartCode(item.partCode)}^FS
    ^FO450,235
    ${bolderBiggerSize}
    ^FD${item.quantity}^FS
    ${drawHorizontalLine(15, 290)}
    ${inverted ? drawHorizontalLineInverted(15, 290) : ''}
    ^FO60,305
    ^ADN,25,12^FR
    ^FDDESCRIPCION^FS

    ${drawVerticalLine(320, 290, 110)}
    ${inverted ? drawVerticalLineInverted(320, 290, 110) : ''}

    ^FO335,305
    ${titleSize}
    ^FDAGENCIA^FS

    ${drawVerticalLine(430, 290, 217)}
    ${inverted ? drawVerticalLineInverted(430, 290, 217) : ''}

    ^FO465,305
    ${titleSize}
    ^FDCONCESIONARIO^FS
    ${drawHorizontalLine(15, 330)}
    ${inverted ? drawHorizontalLineInverted(15, 330) : ''}
    ^FO30,350
    ${slimSize}
    ^FD${item.partName.toUpperCase().substring(0, 23)}^FS
    ^FO365,355
    ${smallSize}
    ^FD${item.agencyCode}^FS
    ^FO440,350
    ${slimSize}
    ^FD${item.dealer.toUpperCase().substring(0, 18)}^FS
    ^FO460,415
    ${titleSize}
    ^FDNOMBRE AGENCIA^FS
    ${drawHorizontalLineComplete(430, 440, 225)}
    ${inverted ? drawHorizontalLineInvertedComplete(430, 440, 225) : ''}
    
    ${backgroundInverted(
    inverted,
    {'positionX': 433, 'positionY': 440},
    {'width': 225, 'heigth': 67}
  )}
      ^FO435,460
      ${slimSize}
      ^FD${item.agencyName.toUpperCase().substring(0, 17)}^FS
      
      ${drawHorizontalLineComplete(430, 440, 225)}
      ^FO435,520
      ^ADN,30,12^FR
      ^FDOR: ${item.orderRepair}^FS
      ^FO430,440
      ^GB225,1,3^FS
      ${inverted ? drawHorizontalLineInvertedComplete(430, 440, 225) : ''}
      ${barcodeBorder}
      ${barcode}
    ^FO25,585
    ${smallSize}
    ^FDCODIGO IMPRESION: ${item.printCode || 'N/A'}^FS

    ^XZ`;
};
